export const buildDropdowns = (role: string, merchstore: any, reassignAction: any, redirectAction: any) => {
  const dropdowns = {
    viewEdit: {
      title: "View/Edit",
      id: `${merchstore.storeCode}-view`,
      action: () => {
        redirectAction();
      }
    },
    close: {
      title: "Close",
      id: `${merchstore.storeCode}-close`,
      action: () => {
        alert("Need to add logic here for Close")
      }
    },
    reassign: {
      title: "Reassign",
      id: `${merchstore.storeCode}-reassign`,
      action: () => {
          reassignAction();
      }
    }
  }

  const merchologistDropdowns = [
    dropdowns.viewEdit,
    dropdowns.close
  ]

  const adminDropdowns = [
    dropdowns.viewEdit,
    dropdowns.close
  ]

  const superuserDropdowns = [
    dropdowns.viewEdit,
    dropdowns.reassign,
    dropdowns.close
  ]

  switch (role) {
    case "SUPERUSER":
      return superuserDropdowns;

    case "MERCHOLOGIST": 
      return merchologistDropdowns;

    case "ADMIN":
      return adminDropdowns;

    default:
      return adminDropdowns;

  }
}